import { Link } from "react-router-dom";
import { Mail, Github, Globe  } from "lucide-react";
import Favicon from '/public/favicon.ico';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold mb-4">
              <img src={Favicon} alt="Favicon" className="h-6 w-6 rounded-full object-contain text-primary" /> 
               <span className="bg-gradient-to-r from-red-600 via-orage-500 to-red-500 bg-clip-text text-transparent">
            PortfolioHub
          </span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-md mb-4">
              Contactless portfolio sharing platform built for CIIT students. 
              Showcase your work instantly with NFC and QR technology.
            </p>
            <div className="flex items-center gap-3">
              <a 
                href="mailto:hello@portfoliohub.ciit.edu.ph" 
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-muted hover:bg-muted-foreground/10 transition-colors"
                aria-label="Email"
              >
                <Mail className="h-4 w-4" />
              </a>
              <a 
                href="https://github.com/Innewgen" 
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-muted hover:bg-muted-foreground/10 transition-colors"
                aria-label="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Github className="h-4 w-4" />
              </a>
              <a 
                href="https://innewgen.com" 
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-muted hover:bg-muted-foreground/10 transition-colors"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Globe className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/#features" className="text-muted-foreground hover:text-foreground transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/#how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/explore" className="text-muted-foreground hover:text-foreground transition-colors">
                  Explore Portfolios
                </Link>
              </li>
              {/* <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/docs" className="text-muted-foreground hover:text-foreground transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-muted-foreground hover:text-foreground transition-colors">
                  Support
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} PortfolioHub by INNEWGEN PH. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground">
            Built for <span className="text-primary font-medium">CIIT College of Arts and Technology</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
